import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "showText", "hideText"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
    if (this.hasShowTextTarget && this.hasHideTextTarget) {
      this.showTextTarget.classList.toggle("hidden")
      this.hideTextTarget.classList.toggle("hidden")
    }
  }
}
